import { CATEGORIES_ORDER, LEVELS_ORDER } from './constants';
import { useSelector } from 'react-redux';
import { selectAuthData } from '@/containers/Login/AuthSelectors';

const useGamification = ({userAchievements}) => {
    const isLocalOrStaging = location.hostname.includes('localhost') || location.hostname.includes('staging');
    const { authorizedSites, name, firstname, createdAt } = useSelector(selectAuthData)

    const numberOfBusinessVertical = authorizedSites?.length || 0;
    const businessVerticalMap = numberOfBusinessVertical === 1 ? authorizedSites[0].business_type : 'energy';
    const categories = []
    CATEGORIES_ORDER.map((category) => {
        const snapshot = userAchievements.find((snapshot) => {
            const relatedAchievementModel = snapshot.achievement
            return relatedAchievementModel.technical_name === category.id;
        });
        if (snapshot) {
            const achievement = snapshot.achievement
            const allLevels = achievement.levels || [];
            const currentLevelOrder = snapshot.current_level?.order || 0
            const nextLevelOrderId = currentLevelOrder + 1;
            const nextLevel = allLevels.find(level => level.order === nextLevelOrderId);
            categories.push({
                id: achievement.technical_name,
                name: achievement.name,
                acquired: snapshot.sales_count || 0,
                total: nextLevel?.gap?.[businessVerticalMap] || 0,
                currentLevelOrder,
                currentLevelKey: snapshot.current_level?.icon || 'empty',
            });
        }
    });

    const totalCategories = CATEGORIES_ORDER.length;
    const levelSummaries = LEVELS_ORDER.map(({ key, order }) => {
        const count = categories.filter(c => c.currentLevelOrder >= order).length;
        return {
            levelKey: key,
            order,
            count,
            total: totalCategories,
            progress: totalCategories > 0 ? (count / totalCategories) * 100 : 0,
        };
    });

    return {
        categories,
        levelSummaries,
        name,
        firstname,
        createdAt,
        isLocalOrStaging,
    }
}

export default useGamification
